import dayjs from "@eisox/dayjs";
import { DateField as DSDateField, Field, type DateFieldSingleProps, type FieldClassNames } from "@eisox/design-system";

import { useFieldContext } from "../form.context";
import { FieldErrors } from "./field-errors.component";

type RootProps = Omit<DateFieldSingleProps, "format" | "mode" | "onValueChange" | "value">;

interface DatetimeFieldProps extends RootProps {
  label?: string;
  description?: string;
  classNames?: FieldClassNames;
  withoutCalendar?: boolean;
}

/** The form keeps its value as a local-time `YYYY-MM-DDTHH:mm` string, as the API expects. */
const DatetimeField: React.FC<DatetimeFieldProps> = ({
  label,
  description,
  classNames,
  withoutCalendar = false,
  children,
  ...rootProps
}) => {
  const field = useFieldContext<string>();
  const parsed = field.state.value && dayjs(field.state.value).isValid() ? dayjs(field.state.value) : null;

  return (
    <Field.Root className={classNames?.root}>
      <Field.Label className={classNames?.label}>{label}</Field.Label>
      <Field.Description className={classNames?.description}>{description}</Field.Description>
      <Field.Control
        render={
          <DSDateField.Root
            {...rootProps}
            className={classNames?.control}
            format="L LT"
            value={parsed}
            onValueChange={value => field.handleChange(value ? value.format("YYYY-MM-DDTHH:mm") : "")}
          >
            <DSDateField.Input
              onBlur={() => {
                field.handleBlur();
              }}
            >
              {children}
              {!withoutCalendar && <DSDateField.Trigger />}
            </DSDateField.Input>
            {!withoutCalendar && (
              <DSDateField.Content>
                <DSDateField.Calendar />
              </DSDateField.Content>
            )}
          </DSDateField.Root>
        }
      />
      <FieldErrors className={classNames?.error} />
    </Field.Root>
  );
};

export { DatetimeField };
export type { DatetimeFieldProps };
